import { FormEvent, useEffect, useState } from 'react';
import { APP_SETTINGS_DEFAULTS, type AppSettings } from '@rosita/shared';
import { api, extractError } from '../../../lib/api';
import { useToast } from '../../../components/admin/Toast';
import { inputClass, primaryBtn } from './shared';

export default function GeneralTab(): JSX.Element {
  const toast = useToast();
  const [newBadgeExpiryDays, setNewBadgeExpiryDays] = useState<number>(
    APP_SETTINGS_DEFAULTS.newBadgeExpiryDays
  );
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    void (async () => {
      try {
        const res = await api.get<AppSettings>('/admin/settings');
        setNewBadgeExpiryDays(res.data.newBadgeExpiryDays);
      } catch (err) {
        toast.error(extractError(err, 'Falha ao carregar configurações'));
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put<AppSettings>('/admin/settings', {
        newBadgeExpiryDays,
      });
      setNewBadgeExpiryDays(res.data.newBadgeExpiryDays);
      toast.success('Configurações guardadas.');
    } catch (err) {
      toast.error(extractError(err, 'Falha ao guardar configurações'));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p className="text-sm text-admin-muted">A carregar…</p>;
  }

  return (
    <form onSubmit={handleSubmit} className="grid max-w-xl gap-4">
      <div>
        <label className="block text-sm font-medium text-admin-text-soft">
          Dias até remover destaque "Novo"
        </label>
        <input
          type="number"
          min={1}
          max={365}
          value={newBadgeExpiryDays}
          onChange={(e) => setNewBadgeExpiryDays(Number(e.target.value))}
          required
          className={`${inputClass} mt-1 w-32`}
        />
        <p className="mt-1 text-xs text-admin-muted">
          Tempo durante o qual produtos novos mostram o destaque "Novo" na loja.
          Aplica-se apenas a produtos com a opção "Destacar como Novo" ativa.
        </p>
      </div>

      <div>
        <button
          type="submit"
          disabled={saving || newBadgeExpiryDays < 1 || newBadgeExpiryDays > 365}
          className={primaryBtn}
        >
          {saving ? 'A guardar…' : 'Guardar'}
        </button>
      </div>
    </form>
  );
}
